var map = {
	"./bxzj-active.png": "6feb",
	"./bxzj.png": "c610",
	"./cwzb-active.png": "1074",
	"./cwzb.png": "8f78",
	"./gspj-active.png": "e16a",
	"./gspj.png": "ecdb",
	"./gzfx-active.png": "f6f1",
	"./gzfx.png": "924c",
	"./jgdy-active.png": "c138",
	"./jgdy.png": "180f",
	"./rzrj-active.png": "4bfd",
	"./rzrj.png": "3de4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10bf";